import { PropType } from 'vue';
import theme from '../../theme';

export const AccordionGeneralProps = {
  borderColor: {
    type: String as PropType<string>,
    default: theme.border,
  },
  borderPosition: {
    type: String as PropType<string>,
    default: 'middle',
    validator: (value: string) => ['middle', 'bottom'].includes(value),
  },
  textColor: {
    type: String as PropType<string>,
    default: theme.fontHeading,
  },
  title: {
    type: String as PropType<string>,
    required: true,
  },
  titleComponent: {
    type: String as PropType<string>,
    default: 'h4',
  },
  titleFontWeight: {
    type: [String, Number] as PropType<string | number>,
    default: 800,
  },
  iconColor: {
    type: String as PropType<string>,
    default: theme.button,
  },
  chevronSide: {
    type: String as PropType<string>,
    validator: (side: string) => ['right', 'left'].includes(side),
    default: 'right',
  },
};
